var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("JadeBox", { attrs: { hasPadding: false } }, [
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        [
          _c(
            "jade-text",
            { staticClass: "title", attrs: { variant: "heading-medium" } },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          ),
          !_vm.$slots.description
            ? _c(
                "jade-text",
                {
                  staticClass: "description",
                  attrs: { variant: "text-medium" },
                },
                [_vm._v(" " + _vm._s(_vm.description) + " ")]
              )
            : _c(
                "div",
                { staticClass: "description" },
                [_vm._t("description")],
                2
              ),
          _vm._t("trailing"),
        ],
        2
      ),
      _c("img", { attrs: { src: _vm.imageUrl, width: "82", height: "82" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }